'use client';

import { Button } from '@/shared/components/atoms/Button';
import { useRouter } from 'next/navigation';

export default function NotFound() {
    const router = useRouter();
    const goToHome = () => {
        router.push('/');
    };
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
            <h1 className="text-4xl font-bold">404</h1>
            <p className="text-lg text-gray-600">페이지를 찾을 수 없습니다</p>
            <Button
                variant="outline"
                onClick={goToHome}
            >
                홈으로 돌아가기
            </Button>
        </div>
    )
} 